// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20Ti1","left":"styles_left__Puqui"};